<div class="selected-items" *ngIf="selectedItems.length && !folderPickerInput?.selectedList?.hide">
  <div class="selected-item"
       [class.folder]="selectedItem?.isFolder"
       *ngFor="let selectedItem of selectedItems">{{selectedItem?.title | translate}}</div>
</div>
<ion-button class="page-button" color="secondary" (click)="showTree()">{{ (folderPickerInput?.selectedList?.viewButton ?? 'MGMT_LIST.Edit_Selections') | translate }}</ion-button>

